import { to } from '@/fit-components/common/util';
import { getBlackList } from './api';
import { BlackListConfigItem } from './types';
/**
 * 根据banner的actListId配置决定是否展示banner
 * @param bannerConfig
 * @returns boolean
 */
export const checkBlackList = async (bannerConfigItem: BlackListConfigItem) => {
  const { actListId, qryType } = bannerConfigItem;
  const [err, res] = await to(getBlackList({ actListId, qryType }));
  if (res && !err) {
    return true;
  }
  return false;
};
